module.exports = __webpack_public_path__ + "static/media/bigthree-1.c505544d.jpg";